<script setup lang="ts">
import type { BreadcrumbItem } from "@/components/BreadcrumbNav.vue";
import BreadcrumbNav from "@/components/BreadcrumbNav.vue";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import MainNav from "@/components/MainNav.vue";
import NotificationsList from "@/notifications/NotificationsList.vue";
import { useGetSettings } from "@/settings/settingsCrud";
import { OpenNewWindow } from "@iconoir/vue";
import LoggedIn from "./LoggedIn.vue";

const { settings, getSettingsStatus } = useGetSettings();

defineProps<{ breadcrumbs?: Array<BreadcrumbItem> }>();
</script>

<template>
  <LoggedIn v-slot="{ me, canAccess }">
    <div class="management-layout">
      <MainNav :can-access="canAccess" />
      <div class="main-layout">
        <main>
          <header class="container container-lg box column">
            <BreadcrumbNav v-if="breadcrumbs" :items="breadcrumbs" />
            <NotificationsList />
            <slot name="header" />
          </header>
          <div class="container container-lg">
            <slot :me="me" />
          </div>
        </main>
        <footer>
          <nav
            aria-labelledby="footer-nav-label"
            class="box container container-lg"
          >
            <h2 id="footer-nav-label" class="visually-hidden">
              Footernavigation
            </h2>
            <HandleQueryStatus :query-status="getSettingsStatus">
              <ul role="list" class="row">
                <li>
                  <a
                    :href="settings?.privacyPolicyUrl"
                    aria-label="Datenschutzerklärung - Link öffnet einen neuen Tab"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="nav-item"
                  >
                    <OpenNewWindow />
                    Datenschutzerklärung
                  </a>
                </li>
                <li>
                  <a
                    :href="settings?.impressUrl"
                    aria-label="Impressum - Link öffnet einen neuen Tab"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="nav-item"
                  >
                    <OpenNewWindow />
                    Impressum
                  </a>
                </li>
              </ul>
            </HandleQueryStatus>
          </nav>
        </footer>
      </div>
    </div>
  </LoggedIn>
</template>

<style scoped>
.management-layout {
  display: flex;
  flex-direction: column;
  block-size: 100vh;
}

.main-layout {
  /* XXX safari 18.7 does not support the logical property overflow-block */
  overflow-y: auto;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

main {
  flex-grow: 1;
}

footer {
  position: sticky;
  inset-block-end: 0;
  inset-inline: 0;
  background-color: var(--bg-color-footer);
  box-shadow: var(--shadow);

  .nav-item {
    text-decoration: none;
  }
}

@media (min-width: 40rem) {
  .management-layout {
    flex-direction: row;
  }
}
</style>
